import { NgModule } from '@angular/core';
import { InfoModule } from '../info/info.module';
import { CardBasicComponent } from './card-basic/card-basic.component';
import { CardPackageComponent } from './card-package/card-package.component';
import { CardResponsiveSliderComponent } from './card-responsive-slider/card-responsive-slider.component';
import { CardSliderComponent } from './card-slider/card-slider.component';
import { CardTopicCardComponent } from './card-topic-card/card-topic-card.component';
import { CardTopicComponent } from './card-topic/card-topic.component';
import { CardWideComponent } from './card-wide/card-wide.component';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { LocalizePipe } from '../../localize/localize.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { UsersFeedbackComponent } from '../../standalone-components/users-feedback/users-feedback.component';
import { UnescapePipe } from '../shared/pipes/unescape.pipe';

@NgModule({
	declarations: [
		CardBasicComponent,
		CardPackageComponent,
		CardResponsiveSliderComponent,
		CardSliderComponent,
		CardTopicComponent,
		CardTopicCardComponent,
		CardWideComponent
	],
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		RouterModule,
		LocalizePipe,
		TranslateModule,
		InfoModule,
		UsersFeedbackComponent,
		UnescapePipe,
	],
	exports: [
		CardBasicComponent,
		CardPackageComponent,
		CardResponsiveSliderComponent,
		CardSliderComponent,
		CardTopicComponent,
		CardTopicCardComponent,
		CardWideComponent,
	]
})
export class CardModule { }
